import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const VehicleIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "VehicleIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.5737 19.9683C18.2358 19.9683 17.1475 18.8794 17.1475 17.5415V17.0649H6.85303V17.5415C6.85303 18.8794 5.76416 19.9683 4.42627 19.9683C3.08838 19.9683 2 18.8794 2 17.5415V12.9116C2 11.4487 3.18994 10.2593 4.65234 10.2593H19.3477C20.8101 10.2593 22 11.4487 22 12.9116V17.5415C22 18.8794 20.9116 19.9683 19.5737 19.9683ZM6.35303 16.0649H17.6475C17.9238 16.0649 18.1475 16.2886 18.1475 16.5649V17.5415C18.1475 18.3286 18.7871 18.9683 19.5737 18.9683C20.3603 18.9683 21 18.3286 21 17.5415V12.9116C21 12.0005 20.2588 11.2593 19.3477 11.2593H4.65234C3.74121 11.2593 3 12.0005 3 12.9116V17.5415C3 18.3286 3.63965 18.9683 4.42627 18.9683C5.21289 18.9683 5.85303 18.3286 5.85303 17.5415V16.5649C5.85303 16.2886 6.07666 16.0649 6.35303 16.0649Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.4609 11.2593H4.53955C4.39209 11.2593 4.25195 11.1938 4.15723 11.0815C4.06202 10.9683 4.02198 10.8198 4.04688 10.6743L4.81446 6.23291C5.03467 4.95752 6.1338 4.03174 7.42774 4.03174H16.5723C17.8667 4.03174 18.9658 4.95752 19.186 6.23291L19.9536 10.6743C19.9785 10.8198 19.9385 10.9683 19.8433 11.0815C19.7485 11.1938 19.6084 11.2593 19.4609 11.2593ZM5.1333 10.2593H18.8672L18.2007 6.40283C18.0635 5.60888 17.3784 5.03174 16.5723 5.03174H7.42773C6.62158 5.03174 5.93701 5.60889 5.7998 6.40283L5.1333 10.2593Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.6475 14.2153H15.9585C15.6821 14.2153 15.4585 13.9917 15.4585 13.7153C15.4585 13.439 15.6821 13.2153 15.9585 13.2153H17.6475C17.9238 13.2153 18.1475 13.439 18.1475 13.7153C18.1475 13.9917 17.9238 14.2153 17.6475 14.2153Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.04199 14.2153H6.35303C6.07666 14.2153 5.85303 13.9917 5.85303 13.7153C5.85303 13.439 6.07666 13.2153 6.35303 13.2153H8.04199C8.31836 13.2153 8.54199 13.439 8.54199 13.7153C8.54199 13.9917 8.31836 14.2153 8.04199 14.2153Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.4609 10.52C19.2647 10.52 19.0786 10.4038 18.999 10.2114C18.8936 9.95557 19.0147 9.66358 19.2695 9.55811L21.3086 8.71436C21.5659 8.60889 21.856 8.72998 21.9619 8.98487C22.0674 9.24073 21.9463 9.53272 21.6914 9.63819L19.6524 10.4819C19.5894 10.5083 19.5249 10.52 19.4609 10.52Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M4.53955 10.52C4.47559 10.52 4.41113 10.5083 4.34863 10.4819L2.30908 9.63818C2.05371 9.53271 1.93262 9.24072 2.03808 8.98486C2.14355 8.72998 2.43798 8.60888 2.69091 8.71435L4.73046 9.5581C4.98583 9.66357 5.10692 9.95556 5.00146 10.2114C4.92187 10.4038 4.73584 10.52 4.53955 10.52Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default VehicleIcon;
